/**
 * @voltxampere/ui — 74HC00 quad NAND CMOS variant (Sprint 42-1)
 *
 * Reference: TI SN74HC00. CMOS sibling of the Sprint 41-4 7400. Same
 * canonical `digital-gate` engine type via schemaType — engine touch
 * sıfır per Sprint 42 zero-diff baseline.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic74hc00 = {
    id: "74hc00",
    nameTr: "74HC00 (4'lü NAND CMOS, DIP-14)",
    nameEn: "74HC00 (Quad NAND CMOS, DIP-14)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "74HC00",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NAND",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        propagationDelay: 8e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-74hc00.js.map